import { EventStatus, type GetEventResponse } from "interfaces/events.interface";
import { getOfflineEventPath } from "utils/offlineAccessRoutes";

export function endedEventAccessRedirect(
  event: GetEventResponse | null | undefined,
  fallbackLinkId?: string | null,
): string | null {
  if (typeof event?.id !== "string" || !event.id.trim() || event.status !== EventStatus.Ended) {
    return null;
  }
  return getOfflineEventPath({
    eventId: event.id,
    linkId: event.postEventAccessLinkId || fallbackLinkId,
  });
}
